export default {
  methods: {
    getBootstrapLightClass(color) {
      const map = {
        '#007bff': 'bg-light-primary',
        '#17a2b8': 'bg-light-info',
        '#28a745': 'bg-light-success',
        '#dc3545': 'bg-light-danger',
        '#ffc107': 'bg-light-warning',
      }
      return map[color] || 'bg-light-secondary'
    },
    getColorMap() {
      return {
        primary: '#007bff',
        info: '#17a2b8',
        danger: '#dc3545',
        success: '#28a745',
        warning: '#ffc107',
        secondary: '#6c757d',
      }
    },
    updateHoverColor(color) {
      const dropdown = this.$el.querySelector('.select-status-dropdown')
      if (dropdown) {
        dropdown.style.setProperty('--hover-color', color || '#6c757d')
      }
    },
  },
}
